import { Component, OnInit, ViewChild, ElementRef, OnChanges, SimpleChanges, Input, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BaseInputDirective } from '../base-input.directive';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SsnMaskPipe } from '../../../utility/ssn-mask.pipe';
import { NgxMaskDirective } from 'ngx-mask';
import { CommonModule } from '@angular/common';
import { MatFormField } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';

 
@Component({
  selector: 'app-ssn-input',
  templateUrl: './ssn-input.component.html',
  styleUrls: ['./ssn-input.component.css'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports :[ReactiveFormsModule, FormsModule,SsnMaskPipe, NgxMaskDirective, CommonModule, MatFormField, MatInputModule, MatButtonModule],
})
export class SsnInputComponent extends BaseInputDirective implements OnInit, OnChanges {
  @Input() showViewSSNButton: boolean = false;
  @Input() hasSSN: boolean = false;
  @Input() employeeId: number;
  hasMask: boolean;

  @ViewChild('ssnInput') input: ElementRef;
  private isEditing = false;

  
 



  ngOnInit() {
    super.ngOnInit();
    this.hasMask = this.fgInfo.mask && this.fgInfo.mask.trim() !== '';
  }

  ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);

    if (changes['readonly'] != null) {
      if (this.readonly) {
        this.stopEditing();
      }
    }
    this.hasMask = this.fgInfo && this.fgInfo.mask && this.fgInfo.mask.trim() !== '';
  }

  getCanEdit() {
    return this.isEditing || !this.formControl.value;
  }

  onFocus() {
    if (this.getCanEdit()) {
      this.startEditing();
      this.input.nativeElement.value = null;
    }
  }

  onFocusOut() {
    if (this.formControl.valid) {
      this.stopEditing();
    }
  }

  toggleEditSsn() {
    // field should be editable, empty, and type should be text
    this.isEditing = true;
    this.formControl.patchValue(null);
    this.input.nativeElement.type = 'text';
  }

  showEdit() {
    return this.getReadonly() && !this.disabled && !this.readonly;
  }

  getReadonly() {
    return !this.isEditing && this.formControl.value;
  }

  private startEditing() {
    this.isEditing = true;
    this.input.nativeElement.type = 'text';
  }

  private stopEditing() {
    if (this.input) {
      this.input.nativeElement.type = 'text';
      if (this.input.nativeElement.value) {
        this.input.nativeElement.value =
          '***-**-' +
          this.input.nativeElement.value.substring(
            this.input.nativeElement.value.length - 4,
            this.input.nativeElement.value.length,
          );
      }
    }
    this.isEditing = false;
  }
}
